"use client";

import { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";

import type { AccordionProps } from "./accordion.types";

import s from "./accordion.module.scss";

const Accordion = ({
  id,
  title,
  children,
  showAccordion = true,
  showClosed = true,
  icon,
  customStyles
}: AccordionProps) => {
  const [expanded, setExpanded] = useState<string | false>(
    showClosed ? false : id
  );

  useEffect(() => {
    setExpanded(showClosed ? false : id);
  }, [showClosed, id]);

  return showAccordion ? (
    <div
      className={`${customStyles?.root || s.wrapper} ${expanded === id ? s.expanded : ""}`}
    >
      <div
        className={`card-headline ${[s["card_headline"]]} ${customStyles?.headline || ""}`}
        id={id}
        data-testid="accordion"
        onClick={() => setExpanded(expanded === id ? false : id)}
        role="button"
        aria-expanded={expanded === id}
      >
        {icon && <div className={`card-icon ${s["card_icon"]}`}>{icon}</div>}
        <div className="card-body">
          <h2
            className={`${s["card-title"]} ${customStyles?.title || "card-title"}`}
          >
            {title}
          </h2>
        </div>
        <div className="card-action">
          <button
            aria-label="Botão de ação"
            className={`card-action-button ${s["card_action_button"]}`}
            type="button"
          >
            <FontAwesomeIcon
              icon={faChevronDown as IconProp}
              style={{ color: "var(--token-colors-neutral-lnk-light)" }}
              fontSize={22}
              className={`${s.icon} ${expanded === id ? s["icon_rotated"] : ""}`}
            />
          </button>
        </div>
      </div>
      <div
        data-testid="accordion-details"
        className={`${customStyles?.body || s["accordion_body"]} ${expanded === id ? customStyles?.expanded || s.expanded : ""}`}
      >
        <div>{children}</div>
      </div>
    </div>
  ) : null;
};
export default Accordion;
